import React from 'react';

const PageLoadingIndicator = () => <div className="page-loading">
    <i className="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <span className="sr-only">Loading...</span>
</div>;

export default PageLoadingIndicator;
